var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "OverlayDialog",
    {
      attrs: {
        id: _vm.modalId,
        "show-trigger": false,
        "modal-button-label": "Fermer",
      },
    },
    [
      _c("PriceDetailsContent", {
        attrs: {
          id: _vm.id,
          "offer-type": _vm.offerType,
          "offer-name": _vm.offerName,
          "offer-price": _vm.offerPrice,
          "price-details": _vm.priceDetails,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }